// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"a2dbebf5","315":"692b6593","453":"8e14a33e","856":"5e4a9463"}[chunkId] + ".chunk.js";
};